import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    min-width: ", ";\n    max-width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Modal } from '../Modal';
import { Paper } from '../Paper';

function setWidth(width, defaultWidth) {
  return width ? typeof width === 'number' ? "".concat(width, "px") : width : "".concat(defaultWidth, "px");
}

var StyledDialog = styled(Paper)(_templateObject(), function (_ref) {
  var modals = _ref.theme.modals,
      minWidth = _ref.minWidth;
  return setWidth(minWidth, modals.minWidth);
}, function (_ref2) {
  var modals = _ref2.theme.modals,
      maxWidth = _ref2.maxWidth;
  return setWidth(maxWidth, modals.maxWidth);
});
export function Dialog(_a) {
  var children = _a.children,
      _a$paperComponent = _a.paperComponent,
      PaperComponent = _a$paperComponent === void 0 ? StyledDialog : _a$paperComponent,
      props = __rest(_a, ["children", "paperComponent"]);

  return React.createElement(Modal, Object.assign({}, props), React.createElement(PaperComponent, {
    level: 'modal'
  }, children));
}